import { StepHandle } from "..";
import { InformationStepData, Step } from "../../types";
import { WorkflowManager } from "../../WorkflowManager";

export class InformationStepHandle extends StepHandle<InformationStepData> {
    constructor(manager: WorkflowManager, step: Step<InformationStepData>, tags: string[]) {
        super(manager, step, tags);
    }

    async selectVariant() {
        // Noop
    }

    /**
     * The way that this step expects to be rendered.
     */
    getContent() {
        return this.step.data.content;
    }
}
